import { useState } from "react";
import { Link } from "react-router-dom";
import { authClient } from "../../lib/auth-client";
import { Button, Card, Field, Input, PageTitle } from "../../components/ui";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      // Better Auth: リセットリンクをメール送信。成否に関わらず同じ表示（アカウント列挙対策・[19] §6.6）
      await authClient.requestPasswordReset({ email, redirectTo: "/reset-password" });
    } finally {
      setDone(true);
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-md">
      <PageTitle title="パスワードの再設定" />
      <Card>
        {done ? (
          <div className="space-y-3 text-center">
            <p className="text-sm text-slate-600">
              入力されたメールアドレスが登録されている場合、再設定用のリンクを送信しました。メールをご確認ください。
            </p>
            <Link to="/login">
              <Button variant="ghost">ログインにもどる</Button>
            </Link>
          </div>
        ) : (
          <form className="space-y-4" onSubmit={onSubmit}>
            <p className="text-sm text-slate-600">
              登録済みのメールアドレスを入力してください。再設定用リンクをお送りします。
            </p>
            <Field label="メールアドレス">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Field>
            <Button type="submit" className="w-full" disabled={loading}>
              再設定メールを送る
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
